
import DistributionUserListComponent from "../../../components/distribution_users/Index.vue";

export default {
  components: {
    DistributionUserListComponent,
  },
};
